/* Import TinyMCE */
import tinymce from 'tinymce';

// Default icons are required for TinyMCE 5.3 or above 
import 'tinymce/icons/default';

// A theme is also required 
import 'tinymce/themes/silver';

// Import the skin 
import 'tinymce/skins/ui/oxide/skin.min.css';
 
// Import plugins 
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/help';
import 'tinymce/plugins/image';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/wordcount';

// Import language packs 
import './tinymce/langs/ja';

$(function () {

    $.ajaxSetup({
        headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
    });

    // Dialog
    // $('.js-dialog--close').on('click', function () {
    //     var $parent = $(this).parents('.js-dialog');
    //     $parent.hide();
    // });
    // $('.js-dialog--cancel').on('click', function () {
    //     var $parent = $(this).parents('.js-dialog');
    //     $parent.hide();
    // });
    // $('.js-dialog--mask').on('click', function () {
    //     var $parent = $(this).parents('.js-dialog');
    //     $parent.hide();
    // });

    $('.js-imagePicker--fileInput').on('change', function (input) {
        var $parent = $(input.target).parents('.js-imagePicker');

        if (input.target.files && input.target.files[0]) {
            $('.js-imagePicker--preview', $parent).show();

            var reader = new FileReader();
            reader.onload = function (e) {
                $('.js-imagePicker--preview', $parent).attr('src', e.target.result);
            };

            reader.readAsDataURL(input.target.files[0]);
        }
    });

    // リッチエディタ
    var file_picker_callback = function (cb, value, meta) {
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        if (meta.filetype == "file")
            input.setAttribute('accept', 'application/pdf');
        else if (meta.filetype == "image")
            input.setAttribute('accept', 'image/*');
        else if (meta.filetype == "media")
            input.setAttribute('accept', 'video/*');

        input.onchange = function () {
            var file = this.files[0];

            var fd = new FormData();

            console.log(file);

            fd.append('file', file);

            $.ajax({
                type: 'POST',
                url: '/upload/tinymce',
                data: fd,
                contentType: false,
                processData: false,
                success: function (response) {
                    console.log(response);
                    if (meta.filetype == "file") {
                        cb(response.path, { text: file.name });
                    } else if (meta.filetype == "image") {
                        cb(response.path, { title: file.name, width: '100%', height: 'auto' });
                    } else if (meta.filetype == "media") {
                        cb(response.path, { title: file.name, width: '100%', height: 'auto' });
                    }
                }
            });
        };

        input.click();
    };

    tinymce.init({
        selector: 'textarea.tinymce-editor',
        language: 'ja' ,
        height: 400,
        menubar: false,
        plugins: [
            'advlist autolink lists link image media charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount'
        ],
        toolbar: 'undo redo | formatselect | ' +
            'bold italic forecolor  backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'link image media | ' +
            'removeformat | help',
        file_picker_type: 'file image media',
        file_picker_callback: file_picker_callback,
        content_css: '//www.tiny.cloud/css/codepen.min.css'
    });

});
$(function () {
    $('.side-menu-list-link').on('click', function (e) {
        e.preventDefault();
        $(this).parents('.side-menu-list-item').toggleClass('closed');
        $(this).next('.sub-menu-list').slideToggle();
    });
    $('.nav-menu-item').on('click', function (e) {
        e.preventDefault();
        $('.nav-menu', $(this)).slideToggle(50);
    });
    $('.nav-menu-back').on('click', function (e) {
        e.preventDefault();
        $('.nav-menu', $(this)).slideToggle(50);
    });
    $('.nav-menu-link').on('click', function (e) {
        e.stopPropagation();
    });
    $('.notification-link').on('click', function (e) {
        e.stopPropagation();
    });
    $('.btn-menu').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $('.dashboard-menu').toggleClass('open');
    });

    $('.js-btn-follow').on('click', function(e) {
        const userId = $(this).data('user-id');

        $.ajax({
            method: 'POST',
            url: `/users/${userId}/follow`,
        }).done(function (response) {
            if (response.result == 'ok') {
                if (response.follow) {
                    $(`.js-btn-follow[data-user-id=${userId}]`).addClass('active');
                    $(`.js-btn-follow[data-user-id=${userId}]`).text('フォロー済み');
                } else {
                    $(`.js-btn-follow[data-user-id=${userId}]`).removeClass('active');
                    $(`.js-btn-follow[data-user-id=${userId}]`).text('フォロー');
                }
            }
        }).fail(function (error) {
            console.log(error);
            alert('エラーが発生しました。');
        });
    });
});
